
import React, { useEffect, useState } from 'react'
import { AcountingHeading } from '../common/AcountingHeading'
import { Item } from '../../../common/snippets'
import { Box, Button } from '@mui/material';
import Datepicker from '../../../common/datePicker'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import moment from 'moment'
import DropDownOA from '../../../common/dropDownOA'
import { connect } from 'react-redux'
import { SplitButton } from '../../../common/SplitButton'
import { RefreshSvg } from '../../../common/svg/refresh'
import { focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import { updateAlertError } from '../../../../store/common/common_action'
import { FranchiseeSettlementUpdateData, getCompanyListV2, getFranchiseeBranchList, getFranchiseeSettlementRptData } from '../../../../store/reports/reports_action'
import { statusList } from '../FranchiseePendingTopayReport/constants'
import { getBranchAndCityList } from '../../../../store/generalSetting/GSAction'
import { PostRequestCachedV3 } from '../../../common/api'
import { urls } from '../../../common/constants'
import { columnDefs, columnDefsExcel, convertToInt32, groupTables, headerColDefsExcel, summaryColDefs } from './Constants';
import { useAtom } from 'jotai'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { companySettingsAtom } from '../../../common/jotaiState/commonStateAtoms'
import { downloadMultiTablePDF } from '../../Reports/analysisReport/pdfAutotable'
import { getDecryptedReportParams } from '../../../common/loginDecode'

const FranchiseesettlementReportNew = (props) => {
  const {
    data: { reports }, updateAlertError, getCompanyListV2, getFranchiseeBranchList, getFranchiseeSettlementRptData,
  } = props
  const { franchiseeCompanyV2, reportCompanyV2, franchiseeBranches } = reports
  const [filters, setFilters] = useState({ fromDate: moment(new Date()), toDate: moment(new Date()), fromCompany: '', fromBranch: '', franchisee: '', franchiseeBranch: '', status: statusList[0] })
  const [showTable, setShowTable] = useState(false)
  const reportName = 'Franchisee Settlement'
  const [selectLr, setSelectLr] = useState('')
  const [fromCompanyList, setFromCompanyList] = useState([])
  const [originalFromBranch, setOriginalFromBranch] = useState([])
  const [fromBranchList, setFromBranchList] = useState([])
  const [franchiseeBranchList, setFranchiseeBranchList] = useState([])
  const [franchiseeCompanyList, setFranchiseeCompanyList] = useState([])
  const [originalData, setOriginalData] = useState([]);
  const [columns, setColumns] = useState([])
  const [excelColumns, setExcelColumns] = useState([])
  const [Table1, setTable1] = useState([])
  const [resetFilters, setResetFilters] = useState(false)
  
  const [companySettings] = useAtom(companySettingsAtom)
  const [urlSearchParams] = useSearchParams()
  const searchParams = getDecryptedReportParams(urlSearchParams)
  const allownFormatLR = companySettings?.UseFormattedLRinReports

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intUserID = +searchParams.get('U') || 0
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    isFromUrl = true
  }
  const { intCompanyID, intUserID, strCompanyName } = loginData

  function addDaysToDate(date, days) {
    const newDate = new Date(date)
    newDate.setDate(newDate.getDate() + days)
    return newDate.toISOString().split('T')[0]
  }
  useEffect(() => {
    focusElemnt('fromDate')
  }, [])
  useEffect(() => {
    if (!isEmpty(loginData)) {
      const companylistBody = {
        intCompanyID: intCompanyID,
        intUserID: intUserID,
        intMode: 1,
      }
      getCompanyListV2(companylistBody, true, 24 * 60 * 60 * 1000)
      const franchiseelistBody = {
        intCompanyID: intCompanyID,
        intUserID: intUserID,
        intMode: 0,
      }
      getCompanyListV2(franchiseelistBody, false, 24 * 60 * 60 * 1000)

      let body = {
        intUserID: 0,
        intCompanyID: intCompanyID,
        intBranchID: 0,
        strBranchName: "",
        strBranchCode: "",
        intStateID: 0,
        intCityID: 0,
        intIsActive: 1
      }
      PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, body, false, 24 * 60 * 60 * 1000).then((res) => {
        if (res.status === 'Success') {
          setOriginalFromBranch([...res?.Data?.Table])
          setFromBranchList([{ BranchName: 'All', BranchID: 0 }, ...res?.Data?.Table])
          setFilters((prev) => ({ ...prev, fromBranch: { BranchName: 'All', BranchID: 0 } }))
        }
      })
      const data = {
        intCompanyID: intCompanyID,
        intUserID: intUserID,
        intFranchiseeCompanyID: 0,
      }
      getFranchiseeBranchList(data)
    }
  }, [intUserID])
  useEffect(() => {
    if (filters.fromCompany !== '') {
      const franchiseelistBody = {
        intCompanyID: filters?.fromCompany?.CompanyID,
        intUserID: intUserID,
        intMode: 0,
      }
      getCompanyListV2(franchiseelistBody, false, 24 * 60 * 60 * 1000)

      let body = {
        intUserID: 0,
        intCompanyID:filters?.fromCompany?.CompanyID,
        intBranchID: 0,
        strBranchName: "",
        strBranchCode: "",
        intStateID: 0,
        intCityID: 0,
        intIsActive: 1
      }
      PostRequestCachedV3(urls.getBranchConfigOrEwbillinfo, body, false, 24 * 60 * 60 * 1000).then((res) => {
        if (res.status === 'Success') {
          let newList =  [{ BranchName: 'All', BranchID: 0 }, ...res?.Data?.Table]
          setFromBranchList(newList)
          setFilters((prev) => ({ ...prev, fromBranch: newList[0] }))
        }
      })
    }
  }, [filters.fromCompany])
  useEffect(() => {
    if (franchiseeCompanyV2?.length > 0) {
      let newList = franchiseeCompanyV2?.length > 1 ? [{ CompanyID: 0, CompanyName: 'All' }] : []
      newList?.push(franchiseeCompanyV2)
      setFranchiseeCompanyList(newList)
      setFilters((prev) => ({ ...prev, franchisee: newList[0] }))
    } else {
      setFranchiseeCompanyList([])
    }
  }, [franchiseeCompanyV2])
  useEffect(() => {
    if (filters?.franchisee !== '') {
      const data = {
        intCompanyID: filters?.fromCompany?.CompanyID === 0 ? intCompanyID : filters?.fromCompany?.CompanyID,
        intUserID: intUserID,
        intFranchiseeCompanyID: filters?.franchisee?.CompanyID,
      }
      getFranchiseeBranchList(data)
    }
  }, [filters?.franchisee, filters?.fromCompany])
  useEffect(() => {
    let newData = []
    if (reportCompanyV2?.length > 0) {
      newData = [{ CompanyID: 0, CompanyName: 'All' }, ...reportCompanyV2]
      setFromCompanyList(newData)
      setFilters((prev) => ({ ...prev, fromCompany: newData[0] }))
    } else {
      setFromCompanyList([])
      setFilters((prev) => ({ ...prev, fromCompany: '' }))
    }
  }, [reportCompanyV2])
  useEffect(() => {
    let newData = []
    if (franchiseeCompanyV2?.length > 0) {
      newData = [{ CompanyID: 0, CompanyName: 'All' }, ...franchiseeCompanyV2]
      setFranchiseeCompanyList(newData)
      setFilters((prev) => ({ ...prev, franchisee: newData[0] }))
    } else {
      setFranchiseeCompanyList([])
      setFilters((prev) => ({ ...prev, franchisee: '' }))
    }
  }, [franchiseeCompanyV2])
  useEffect(() => {
    if (filters?.franchisee !== '') {
      const data = {
        intCompanyID: intCompanyID,
        intUserID: intUserID,
        intFranchiseeCompanyID: filters?.franchisee?.CompanyID,
      }
      getFranchiseeBranchList(data)
    }
  }, [filters?.franchisee])
  useEffect(() => {
    if (franchiseeBranches?.length > 0) {
      let newData = [{ BranchID: 0, BranchName: 'All' }, ...franchiseeBranches]
      setFranchiseeBranchList(newData)
      setFilters((prev) => ({
        ...prev,
        franchiseeBranch: newData[0]
      }))
    }
  }, [franchiseeBranches])
  useEffect(()=>{
    if(allownFormatLR===1||allownFormatLR===0){
      setColumns(columnDefs)
      setExcelColumns(columnDefsExcel)
    }else if(allownFormatLR===2){
      let newCols = [...columnDefs]
      let newExcelCols = [...columnDefsExcel]
      newCols[1].header='Formatted LR'
      newCols[1].dataKey='FormattedLRNO'
      setColumns(newCols)
      newExcelCols[1].header = 'Formatted LR'
      newExcelCols[1].dataKey = 'FormattedLRNO'
      setExcelColumns(newExcelCols)
    }else if(allownFormatLR===3){
      let newCols = [...columnDefs]
      const newObject = { header: 'Formatted LRNO', dataKey: 'FormattedLRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '9%', textAlign: 'left' } }
      newCols.splice(2, 0, newObject);
      setColumns(newCols);
      let newExcelCols = [...columnDefsExcel]
      const newExcelObject = { header: 'Formatted LRNO', dataKey: 'FormattedLRNO', xlCol: { dataType: 'string', dataFormatter: null }, headerSx: { width: '10%', textAlign: 'left' }, pdfColSx:{cellWidth: 131.11} }
      newExcelCols.splice(2, 0, newExcelObject);
      setExcelColumns(newExcelCols);
    }
  },[allownFormatLR, columnDefs])

  const handleClick1 = async (isPdf = false) => {
    const diffDays = Math.abs(filters?.toDate.diff(filters?.fromDate, 'days'))
    const isAllSelected = filters?.fromCompany?.CompanyID === 0 || filters?.fromBranch?.BranchID === 0 || filters?.franchisee?.CompanyID === 0 || filters?.franchiseeBranch?.BranchID === 0 

    // if (Math.abs(filters?.toDate.diff(filters?.fromDate, 'days')) > 31) {
    //   updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    // } else 
    if (filters?.fromCompany === '') {
      updateAlertError({ show: true, msg: 'Please Select From Company', nextId: 'fromCompany' })
      return
    } else if (filters?.fromBranch === '') {
      updateAlertError({ show: true, msg: 'Please Select From Branch', nextId: 'fromBranch' })
      return
    } else if (filters?.franchisee === '') {
      updateAlertError({ show: true, msg: 'Please Select Franchisee', nextId: 'franchisee' })
      return
    } else if (filters?.franchiseeBranch === '') {
      updateAlertError({ show: true, msg: 'Please Select Franchisee Branch', nextId: 'franchiseeBranch' })
      return
    } else if (filters?.status === '') {
      updateAlertError({ show: true, msg: 'Please Select Status', nextId: 'status' })
      return
    } else if (isAllSelected && diffDays > 15) {
      updateAlertError({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
      return
    } else if (!isAllSelected && diffDays > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
      return
    } else {
      let body = {
        intCompanyID: filters?.fromCompany?.CompanyID,
        intBranchID: filters?.fromBranch?.BranchID,
        intFranchiseeCompanyID: filters?.franchisee?.CompanyID,
        intFranchiseeBranchID: filters?.franchiseeBranch?.BranchID,
        dtFromDate: moment(filters?.fromDate).format('YYYY-MM-DD'),
        dtToDate: moment(filters?.toDate).format('YYYY-MM-DD'),
        intStatus: filters?.status?.id,
        intUserID: intUserID,
      }
      getFranchiseeSettlementRptData(body).then((res) => {
        if (res?.status === 'Success') {
          if (res?.Table?.length > 0) {
            const Table1 = [...res?.Table1]
            // let intCompanyID = loginData?.intCompanyID
            setTable1(res?.Table1)
            const getSharingPercentage = (companyID, VehicleCompanyID) => {
              const sharingEntry = Table1.find(
                (entry) => entry.SendingCompanyID === companyID && Number(entry.ReceivingCompanyID) === VehicleCompanyID
              );
              return sharingEntry ? sharingEntry.SharingPercentage : 0;
            };

            let newData = res?.Table?.map((val) => {
              const totalAmt = Number(val.PaidAmt) + Number(val.ActualTopayAmt)
              let Charges = 0;
              let NetPayable = 0;

              return {
                ...val,
                GeneratedDateTime: val.GeneratedDateTime === '' || val.GeneratedDateTime === null || val.GeneratedDateTime === undefined ? '' : moment(val.GeneratedDateTime).format('DD-MMM-YYYY'),
                totalItems: Number(val.PaidItems) + Number(val?.TopayItems),
                receiveValue: Number(val.IsReceived) === 1 ? 'Paid' : 'UnPaid',
                receive: Number(val.IsReceived),
                remarks: val.Remarks,
                HasReceivedAtBranch: Number(val.HasReceivedAtBranch) === 1 ? 'Yes' : 'No',
                IsReceived: Number(val.IsReceived),
                Charges: Math.round(Charges),
                NetPayable: Math.round(NetPayable),
                totalAmt: Math.round(totalAmt)
              };
            });
            setOriginalData(newData)
            let newGroupData = groupTables(newData, loginData);
            const newCombinedData = newGroupData?.map(group => {
              const updatedToPayData = group.toPayData?.map(row => {
                if (row.isTotalRow) return row; // We'll update this later
                const VehicleCompanyID = row.VehicleCompanyID;
                const CompanyID = row.CompanyID;
                const DestinationCompanyID = row.DestinationCompanyID;
                const TopayAmt = Number(row.TopayAmt) || 0;
                const PaidAmt = Number(row.PaidAmt) || 0;
                const ActualTopayAmt = Number(row.ActualTopayAmt) || 0;
                const finalSharingCommPer = ((100 - getSharingPercentage(CompanyID, VehicleCompanyID)) / 100);
                const totalAmt = PaidAmt + ActualTopayAmt;
                let Charges = 0;
                let NetPayable = 0;

                if (intCompanyID !== VehicleCompanyID && intCompanyID !== CompanyID && intCompanyID === DestinationCompanyID) {
                  Charges = Number(TopayAmt);
                  NetPayable = 0;
                } else if (intCompanyID !== VehicleCompanyID && intCompanyID === CompanyID && intCompanyID !== DestinationCompanyID) {
                  NetPayable = ((PaidAmt + ActualTopayAmt) * finalSharingCommPer) - PaidAmt;
                  Charges = NetPayable < 0 ? Math.abs(NetPayable) : 0;
                } else if (intCompanyID === VehicleCompanyID && intCompanyID !== CompanyID && intCompanyID !== DestinationCompanyID) {
                  Charges = Number((PaidAmt + ActualTopayAmt) * finalSharingCommPer).toFixed(1);
                  NetPayable = PaidAmt - Charges;
                } else if (intCompanyID === VehicleCompanyID && intCompanyID !== CompanyID && intCompanyID === DestinationCompanyID) {
                  Charges = Number(totalAmt * finalSharingCommPer).toFixed(1);
                  NetPayable = PaidAmt - convertToInt32(Charges);
                } else if (intCompanyID === VehicleCompanyID && intCompanyID === CompanyID && intCompanyID !== DestinationCompanyID) {
                  Charges = 0;
                  NetPayable = TopayAmt;
                }

                return {
                  ...row,
                  GeneratedDateTime: row.GeneratedDateTime ? moment(row.GeneratedDateTime).format('DD-MMM-YYYY') : '',
                  totalItems: Number(row.PaidItems) + Number(row.TopayItems),
                  receiveValue: Number(row.IsReceived) === 1 ? 'Paid' : 'UnPaid',
                  receive: Number(row.IsReceived),
                  remarks: row.Remarks,
                  HasReceivedAtBranch: Number(row.HasReceivedAtBranch) === 1 ? 'Yes' : 'No',
                  IsReceived: Number(row.IsReceived),
                  Charges: Number(Charges),
                  NetPayable: Math.round(NetPayable),
                  totalAmt: Math.round(totalAmt),
                };
              });
              const dataWithoutTotalRow = updatedToPayData.filter(row => !row.isTotalRow);

              let totalRow = {
                isTotalRow: true,
                GeneratedDateTime: 'Total',
                PaidItems: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.PaidItems) || 0), 0),
                TopayItems: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.TopayItems) || 0), 0),
                totalItems: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.totalItems) || 0), 0),
                PaidAmt: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.PaidAmt) || 0), 0),
                ActualTopayAmt: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.ActualTopayAmt) || 0), 0),
                ToPayComm: dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.ToPayComm) || 0), 0),
                totalAmt: Math.round(dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.totalAmt) || 0), 0)),
                Charges: (dataWithoutTotalRow.reduce((acc, row) => Number(acc) + (Number(row.Charges) || 0), 0)).toFixed(1),
                NetPayable: Math.round(dataWithoutTotalRow.reduce((acc, row) => acc + (Number(row.NetPayable) || 0), 0)),
              };

              return {
                ...group,
                toPayData: [...dataWithoutTotalRow, totalRow]
              };
            });

            const subHeadingWithTotals = newCombinedData.map(group => ({
              GeneratedDateTime: group.GeneratedDateTime,
              NetPayable: group.toPayData.find(item => item.isTotalRow)?.NetPayable
            }));
            const grandTotalNetPayable = subHeadingWithTotals.reduce(
              (acc, val) => acc + (Number(val.NetPayable) || 0),
              0
            );

            // Create the total row
            const totalRow = {
              isTotalRow: true,
              GeneratedDateTime: 'Grand Total',
              NetPayable: grandTotalNetPayable
            };

            const updatedSubHeadingWithTotals = [...subHeadingWithTotals, totalRow];
            const reportPayload = {
              id: 'franchisee_settlement_report',
              filters, loginData, Table1,
              reportData: newCombinedData,
              originalData: newData,
              summaryReportData: updatedSubHeadingWithTotals,
              allownFormatLR, columns, excelColumns,
            }
            if (isPdf === true) {
              const pdfCriteriaHeaders = headerColDefsExcel.map(col => ({
                header: col.header,
                field: col.dataKey,
                xlCol: col.xlCol || { dataType: 'string' },
              }))
              const pdfCriteriaData = [{
                fromDate: moment(filters?.fromDate).format('DD-MMM-YYYY'),
                toDate: moment(filters?.toDate).format('DD-MMM-YYYY'),
                fromCompany: filters?.fromCompany?.CompanyName || '',
                fromBranch: filters?.fromBranch?.BranchName || '',
                franchisee: filters?.franchisee?.CompanyName || '',
                franchiseeBranch: filters?.franchiseeBranch?.BranchName || '',
                status: filters?.status?.name || '',
                dataType: 'entry',
              }]              

              const flatMainTableData = newCombinedData.flatMap(group => [
                {
                  dataType: 'subHeader',
                  GeneratedDateTime: group.GeneratedDateTime,
                  colSpan: { 'GeneratedDateTime': (excelColumns.length > 0 ? excelColumns : columnDefsExcel).length },
                  align: { 'GeneratedDateTime': 'left' },
                },
                ...group.toPayData.map(row => ({
                  ...row,
                  dataType: row.isTotalRow ? 'total' : 'entry',
                })),
              ])

              const flatSummaryData = updatedSubHeadingWithTotals.map(row => ({
                ...row,
                dataType: row.isTotalRow ? 'total' : 'entry',
              }))

              const mainVisibleColumns = (excelColumns.length > 0 ? excelColumns : columnDefsExcel).map(col => ({
                ...col,
                field: col.dataKey,
                exportHead: col.header,
                xlCol: col.xlCol || { dataType: 'string' },
                weight: col.weight || 81,                
              }))

              const summaryVisibleColumns = summaryColDefs.map(col => ({
                ...col,
                field: col.dataKey,
                exportHead: col.header,
                xlCol: col.xlCol || { dataType: 'string' },
                weight: col.weight || 81,
              }))

              downloadMultiTablePDF({
                reportName,
                criteriaHeaders: pdfCriteriaHeaders,
                criteriaData: pdfCriteriaData,
                tables: [
                  {
                    tableData: flatMainTableData,
                    visibleColumns: mainVisibleColumns,
                    hideHeader: false,
                    options: { isIncreFontSize: true },
                  },
                  {
                    tableData: flatSummaryData,
                    visibleColumns: summaryVisibleColumns,
                    hideHeader: false,
                    options: { isIncreFontSize: true },
                  },
                ],
                loginData,
              })
              return
            }
            const rid = Date.now().toString()

            if (!window.generatedReports) {
              window.generatedReports = {}
            }

            window.generatedReports[rid] = reportPayload

            window.open(`/view-reportV2?rid=${rid}`, "_blank")
          }
          else {
            updateAlertError({ show: true, msg: 'No Data Found', nextId: 'status' })
            return
          }
        } else {
          updateAlertError({ show: true, msg: res?.ErrMessage, nextId: '' })
          return
        }
      }).catch((err) => {
        console.log(err)
      })
    }
  }

  const handleReset = () => {
    setFilters({ fromDate: moment(new Date()), toDate: moment(new Date()), fromCompany: '', fromBranch: '', franchisee: '', franchiseeBranch: '', status: statusList[0] })
    setSelectLr('')
    setResetFilters(true)
    setTimeout(() => {
      setResetFilters(false)
    }, 0);
  }
  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <AcountingHeading reportName={reportName} />}
      </Item>
      <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px', ...(!isFromUrl && { flexWrap: 'nowrap' }) }}>
        {!isFromUrl && <>
          <Item sx={{ ...sx.itemsx, width: '17%' }}>
            <DropDownOA
              id='company'
              label={'Select Company'}
              defaultvalue={strCompanyName}
              disabled={true}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx} className="disabled-wrapper">
            <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
              GO
            </Button>
          </Item>
        </>}
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: !isFromUrl ? '17%' : 'auto' }} className="input--container bookingDatePicker">
          <Datepicker
            label={`From Date`}
            id='fromDate'
            value={filters?.fromDate}
            dateChange={(date) => {
              setFilters((prev) => ({
                ...prev,
                fromDate: date
              }))
              setShowTable(false)
              focusElemnt('toDate')
            }}
            width={'100%'}
            startDate={'2022-01-01'}
            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: !isFromUrl ? '17%' : 'auto' }} className="input--container bookingDatePicker">
          <Datepicker
            label={'To Date'}
            id='toDate'
            value={filters?.toDate}
            dateChange={(date) => {
              setFilters((prev) => ({
                ...prev,
                toDate: date
              }))
              setShowTable(false)
              focusElemnt('fromCompany')
            }}
            width={'100%'}
            startDate={'2022-01-01'}
            endDate={addDaysToDate(moment().format('YYYY-MM-DD'), 0)}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: !isFromUrl ? '17%' : 'auto' }}>
          <DropDownOA
            id={'fromCompany'}
            label={'From Company'}
            data={fromCompanyList || []}
            defaultvalue={filters?.fromCompany.CompanyName}
            idKey={`CompanyID`}
            dataKey={`CompanyName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                fromCompany: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Company`}
            width="100%"
            nextId={'fromBranch'}
            prevId={'toDate'}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: !isFromUrl ? '17%' : 'auto' }}>
          <DropDownOA
            id={'fromBranch'}
            label={'From Branch'}
            data={fromBranchList || []}
            defaultvalue={filters?.fromBranch?.BranchName}
            idKey={`BranchID`}
            dataKey={`BranchName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                fromBranch: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Branch`}
            width="100%"
            nextId={'franchisee'}
            prevId={'fromCompany'}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: !isFromUrl ? '17%' : 'auto' }}>
          <DropDownOA
            id={'franchisee'}
            label={'Franchisee'}
            data={franchiseeCompanyList || []}
            defaultvalue={filters?.franchisee?.CompanyName}
            idKey={`CompanyID`}
            dataKey={`CompanyName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                franchisee: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Franchisee`}
            width="100%"
            nextId={'franchiseeBranch'}
            prevId={'fromBranch'}
          />
        </Item>

      </Box>
      <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px', ...(!isFromUrl && { flexWrap: 'nowrap', gap: '10px', width: '100%' }) }}>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: !isFromUrl ? '15%' : 'auto' }}>
          <DropDownOA
            id={'franchiseeBranch'}
            label={'Franchisee Branch'}
            data={franchiseeBranchList || []}
            defaultvalue={filters?.franchiseeBranch?.BranchName}
            idKey={`BranchID`}
            dataKey={`BranchName`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                franchiseeBranch: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Branch`}
            width="100%"
            nextId={'status'}
            prevId={'franchisee'}
          />
        </Item>
        <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} style={{ width: !isFromUrl ? '20%' : 'auto' }}>
          <DropDownOA
            id={'status'}
            label={'Status'}
            data={statusList || []}
            defaultvalue={filters?.status?.name}
            idKey={`id`}
            dataKey={`name`}
            onSelect={(val) => {
              setFilters((prev) => ({
                ...prev,
                status: val
              }))
              setShowTable(false)
            }}
            resetFlag={resetFilters}
            isObjArr={true}
            searchPlaceholder={`Search By Status`}
            width="100%"
            nextId={'splitButton'}
            prevId={'franchiseeBranch'}
          />
        </Item>
        {isFromUrl ?
          <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={'SplitButton'}>
            DOWNLOAD PDF
          </Button> : <>
            <Item sx={{ ...sx.itemsx }}
              onKeyDown={(e) => navigation3(e, 'refreshBtn', 'status', () => handleClick1())}
            >
              <SplitButton
                options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                hideToggle={true}
                id1={'splitButton'}
                onClick1={() => handleClick1()}
                prevID={''}
              />
            </Item>
            <Item
              sx={{ ...sx.itemsx, padding: '5px 5px' }}
              id='refreshBtn'
              onKeyDown={(e) => navigation3(e, showTable ? 'excelBtn' : 'fromDate', 'splitButton', () => handleReset())}
              onClick={() => {
                handleReset()
              }}
            >
              <RefreshSvg />
            </Item>
          </>}
      </Box>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = { updateAlertError, getCompanyListV2, getBranchAndCityList, getFranchiseeBranchList, getFranchiseeSettlementRptData, FranchiseeSettlementUpdateData }
export default connect(mapStateToProps, mapDispatchToProps)(FranchiseesettlementReportNew)

